import { styled } from '@mui/material';
import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@/theme/components';
import { Icons } from '@/theme/index';

interface ListingResultsDataViewToggleProps {
  isTableView: boolean;
  onViewChange: (isTableView: boolean) => void;
}

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  border: 'none',
  borderRadius: '0',
  padding: theme.spacing(0.75, 2),
  color: theme.palette.primary.main,
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

export function ListingResultsDataViewToggle({
  isTableView,
  onViewChange,
}: ListingResultsDataViewToggleProps) {
  const [view, setView] = useState<'table' | 'card'>(
    isTableView ? 'table' : 'card'
  );

  const handleViewType = (
    event: React.MouseEvent<HTMLElement>,
    newView: string | null
  ) => {
    if (newView === null) return;
    setView(newView as 'table' | 'card');
    onViewChange(newView === 'table');
  };

  return (
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={handleViewType}
      aria-label="table or card view"
      sx={{
        maxHeight: 39,
        border: '1px solid',
        borderColor: 'primary.main',
      }}
    >
      <CustomToggleButton value="table" aria-label="table view">
        <Icons.ListRounded fontSize="medium" />
      </CustomToggleButton>
      <CustomToggleButton value="card" aria-label="card view">
        <Icons.ViewModule />
      </CustomToggleButton>
    </ToggleButtonGroup>
  );
}
